<template>
    <component :is="template">
        <div>
            <v-row>
                <v-col>
                    <div class="order-content">
                        <v-card tile elevation="0" class="px-12px py-20px pa-md-50px">
                            <div class="tit-wrap tit-wrap--unberline">
                                <h2 class="tit">주문하기</h2>
                            </div>

                            <section class="page-section pt-0">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="tit tit--xs">구매자 정보 입력</h3>
                                    <v-divider class="grey lighten-1 mt-10px" />
                                </div>

                                <div>
                                    <v-row align="center" class="row--x-small">
                                        <v-col cols="12">
                                            <v-text-field v-model="order.buyer.name" placeholder="이름" outlined persistent-placeholder hide-details />
                                        </v-col>
                                        <v-col cols="12">
                                            <div class="w-100 mw-500px">
                                                <v-row align="center" class="row--x-small">
                                                    <v-col>
                                                        <v-select v-model="order.buyer.phone1" v-bind="$attrs" :items="phones" placeholder="연락처" outlined persistent-placeholder hide-details />
                                                    </v-col>
                                                    <v-col cols="auto">-</v-col>
                                                    <v-col>
                                                        <v-text-field v-model="order.buyer.phone2" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()" />
                                                    </v-col>
                                                    <v-col cols="auto">-</v-col>
                                                    <v-col>
                                                        <v-text-field v-model="order.buyer.phone3" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()" />
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="order.buyer.email" placeholder="이메일" outlined persistent-placeholder hide-details />
                                        </v-col>
                                    </v-row>
                                </div>
                            </section>

                            <template>
                                <section class="page-section">
                                    <div class="mb-10px mb-md-20px">
                                        <h3 class="tit tit--xs">수취인 정보 입력</h3>
                                        <v-divider class="grey lighten-1 mt-10px" />
                                    </div>

                                    <div>
                                        <v-row align="center" class="row--x-small">
                                            <v-col cols="12">
                                                <div class="w-100 mw-500px">
                                                    <v-row align="center" class="row--x-small">
                                                        <v-col>
                                                            <v-text-field v-model="order.receiver.name" placeholder="이름" v-bind="$attrs" outlined hide-details/>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row align="center" class="row--x-small">
                                                        <v-col>
                                                            <v-select v-model="order.receiver.phone1" v-bind="$attrs" :items="phones" placeholder="연락처" outlined persistent-placeholder hide-details @click="$refs.kcpCert.open()" />
                                                        </v-col>
                                                        <v-col cols="auto">-</v-col>
                                                        <v-col>
                                                            <v-text-field v-model="order.receiver.phone2" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()" />
                                                        </v-col>
                                                        <v-col cols="auto">-</v-col>
                                                        <v-col>
                                                            <v-text-field v-model="order.receiver.phone3" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()" />
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </section>

                                <section class="page-section pt-0">
                                    <v-checkbox v-model="checkbox" label="구매자 정보와 동일" hide-details class="d-inline-flex ma-0"></v-checkbox>
                                </section>
                            </template>

                            <section class="page-section">
                                <v-divider class="grey darken-4" />
                                <template v-for="(cart, index) in carts">
                                    <v-divider v-if="index" :key="index" />
                                    <pickup-item :key="cart._id" :cart="cart" :needUrl="true" />
                                </template>
                                <v-divider />
                            </section>
                        </v-card>

                        <div v-if="$vuetify.breakpoint.mobile" class="text-center mt-10px mt-md-20px">
                            <v-card tile elevation="0" width="376" class="quick-order pa-12px pa-md-30px">
                                <div class="quick-order-info">
                                    <div class="quick-order-info-item">
                                        <v-row justify="center" align="center" class="row--small font-size-14">
                                            <v-col cols="6">총 상품가격</v-col>
                                            <v-col cols="6"> {{ totalAmount.format() }}원 </v-col>
                                        </v-row>
                                        <v-row justify="center" align="center" class="row--small font-size-14">
                                            <v-col cols="6">보유 캐시</v-col>
                                            <v-col cols="6"> {{ me?.cash.format() }}원 </v-col>
                                        </v-row>
                                        <v-row justify="center" align="center" class="row--small font-size-14">
                                            <v-col cols="6">사용 캐시</v-col>
                                            <v-col cols="6"> -{{ totalAmount.format() }}원 </v-col>
                                        </v-row>
                                        <v-row justify="center" align="center" class="row--small font-size-14">
                                            <v-col cols="6">잔여 캐시</v-col>
                                            <v-col cols="6"> {{ (me?.cash - totalAmount).format() }}원 </v-col>
                                        </v-row>
                                    </div>

                                    <div class="quick-order-info-total font-weight-medium">
                                        <v-divider class="my-10px" />
                                        <v-row justify="center" align="center" class="row--small font-size-14">
                                            <v-col cols="6">총 결제금액</v-col>
                                            <v-col cols="6">
                                                <div class="d-flex justify-center align-center">
                                                    <b class="font-size-18 font-size-md-22 secondary--text">{{ totalAmount.format() }}</b
                                                    ><span class="ml-2px">원</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </div>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="auto">
                    <div class="quick-order-wrap">
                        <v-card tile elevation="0" width="376" class="quick-order pa-12px pa-md-30px">
                            <div class="quick-order-info">
                                <div class="quick-order-info-item">
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">총 상품가격</v-col>
                                        <v-col cols="9" md="8"> {{ totalAmount.format() }}원 </v-col>
                                    </v-row>
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">보유 캐시</v-col>
                                        <v-col cols="9" md="8"> {{ me?.cash.format() }}원 </v-col>
                                    </v-row>
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">사용 캐시</v-col>
                                        <v-col cols="9" md="8"> -{{ totalAmount.format() }}원 </v-col>
                                    </v-row>
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">잔여 캐시</v-col>
                                        <v-col cols="9" md="8"> {{ (me?.cash - totalAmount).format() }}원 </v-col>
                                    </v-row>
                                </div>

                                <div class="quick-order-info-total font-weight-medium">
                                    <v-divider class="my-10px" />
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">총 결제금액</v-col>
                                        <v-col cols="9" md="8">
                                            <div class="d-flex align-center">
                                                <b class="font-size-18 font-size-md-22 secondary--text">{{ totalAmount.format() }}</b
                                                ><span class="ml-2px">원</span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>

                            <div class="quick-order-button mt-10px">
                                <v-row class="row--x-small">
                                    <v-col cols="12">
                                        <v-btn @click="pay" block large color="primary" :disabled="display">결제하기</v-btn>
                                    </v-col>
                                    <!-- <v-col cols="12">
                                        <v-btn to="/mypage/shop/carts" block large outlined color="grey"><span class="grey--text text--darken-3">장바구니</span></v-btn>
                                    </v-col> -->
                                </v-row>
                            </div>
                        </v-card>
                    </div>
                </v-col>
            </v-row>
        </div>

        <div class="mt-20px mt-md-30px">
            <v-row align="center" justify="center" class="row--x-small">
                <v-col cols="auto">
                    <v-btn @click="pay" x-large color="primary" :disabled="display">결제하기</v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn @click="$router.go(-1)" x-large outlined class="white" style="border-color: #9e9e9e !important"><span class="grey--text text--darken-3">취소하기</span></v-btn>
                </v-col>
            </v-row>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import islands from "@/assets/data/islands.json";
import { mdiReceipt, mdiBookOpenPageVariant } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
export default {
    components: {
        PickupItem,
    },
    data() {
        return {
            islands,
            mdiReceipt,
            mdiBookOpenPageVariant,

            me: null,

            order: {
                _id: null,
                pickups: [],

                buyer: {
                    _id: null,
                    name: null,

                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,

                    email: null,
                },

                receiver: {
                    name: null,

                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,
                },

                // shippingAddress: {
                //     postcode: null,
                //     address1: null,
                //     address2: null,
                // },

                // demand: "",
                // shippingAmount: 0,
                // pointAmount: 0,
                // cashbill: {
                //     status: false,
                //     tradeUsage: "소득공제용",
                //     identityNum: null,
                // },

            },

            carts: [],

            phones: ["010", "011", "016", "017", "019"],

            setting: null,

            checkbox: false,

            // tradeUsage: "소득공제용",

            // items: [
            //     { text: "휴대폰 번호", value: "휴대폰번호" },
            //     { text: "현금영수증 카드번호", value: "카드번호" },
            // ],

            // cashbillType: "휴대폰번호",

            display: false,
        };
    },
    async mounted() {
        await this.init();
        this.$nextTick((_) => {
            const content = document.querySelector(".order-content");
            const wing = document.querySelector(".quick-order-wrap");

            const contentTop = content.getBoundingClientRect().top + window.scrollY;

            window.addEventListener("scroll", function () {
                if (window.scrollY >= contentTop) {
                    wing.classList.add("fixed");
                } else {
                    wing.classList.remove("fixed");
                }
            });
        });
    },
    methods: {
        async init() {
            await this.getSetting();
            await this.getMe();
            this.setCarts();
        },

        async getSetting() {
            try {
                let { setting } = await api.v1.shop.setting.get();
                this.setting = setting;
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },

        async getMe() {
            try {
                if (this.logon) {
                    let { me } = await api.v1.me.profile.get();
                    let { _id, name, username, phone, email } = me;
                    let [phone1, phone2, phone3] = phone?.phoneNumberFormat?.()?.split?.("-") || [];

                    this.me = me;
                    this.order.buyer = { _id, name, username, phone, phone1, phone2, phone3, email };
                }
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },

        setCarts() {
            this.carts = this.$store.state.pickupItems;

            if (!this.carts.length) {
                alert("구매하실 상품을 선택해주세요");
                this.$router.go(-1);
                return;
            }
            this.$store.dispatch("checkout");
            this.order.pickups = this.carts.map((cart) => ({ _product: cart.product._id, quantity: cart.quantity }));
        },

        setReceiver(receiver) {
            this.order.receiver = { ...receiver, phone1: receiver.phone[0] || "010", phone2: receiver.phone[1], phone3: receiver.phone[2] };
        },

        validate() {
            try {
                if (!this.logon) {
                    alert("로그인이 필요합니다.");
                    this.$router.push("/login");
                    return false;
                }
                const cash = this.me?.cash || 0;
                if(cash < this.totalAmount) throw new Error("보유 캐시가 부족합니다.");
                
                if (!this.order.buyer.name) throw new Error("구매자 이름을 입력해주세요");
                if (!this.order.buyer.phone) throw new Error("구매자 연락처를 입력해주세요");
                if (!this.order.buyer.email) throw new Error("구매자 이메일을 입력해주세요");

                if (!this.order.receiver.name) throw new Error("수취인 이름을 입력해주세요");
                if (!this.order.receiver.phone) throw new Error("수취인 연락처를 입력해주세요");


                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async pay() {
            try {
                if (this.validate()) {
                    this.display = true;
                    this.order.cashAmount = this.totalAmount;
                    this.order.totalAmount = this.totalAmount;

                    let { order } = await api.v1.dshop.orders.post(this.order);

                    let response = await api.v1.dshop.orders.pay({ _id: order._id });
                    this.$router.push({
                        path: "/dshop/result",
                        query: response,
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.display = false;
            }
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.shop}`);
        },

        accessToken() {
            return this.$store.state.accessToken;
        },

        logon() {
            return !!this.accessToken;
        },

        totalAmount() {
            return this.carts.reduce((totalAmount, cart) => totalAmount + cart.product.salePrice * cart.quantity, 0);
        },

    },
    watch: {
        order: {
            deep: true,
            handler(value) {
                var { phone1, phone2, phone3 } = value.buyer;
                value.buyer.phone = phone1 && phone2 && phone3 ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;

                var { phone1, phone2, phone3 } = value.receiver;
                value.receiver.phone = phone1 && phone2 && phone3 ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;
            },
        },
        checkbox() {
            this.setReceiver(
                !this.checkbox
                    ? { name: null, phone: [] }
                    : {
                          name: this.me.name,
                          phone: this.me.phone?.phoneNumberFormat?.()?.split?.("-") || [],
                      }
            );
        },
    },
};
</script>

<style scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}

.quick-order-wrap {
    width: 376px;
}
.quick-order-wrap.fixed .quick-order {
    position: fixed;
    top: 0;
}
</style>

